module.exports = __webpack_public_path__ + "static/img/yiliaohuagong.2a1be84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/yiliaohuagong.png
// module id = I0+f
// module chunks = 1